import { Col, Container, Row, Image} from 'react-bootstrap'
import { Link } from 'react-router-dom'

import "./style.css"

function Footer() {
	return (
		<Container className='py-5'>
			<hr />
			<Row className='footer'>
				<Col>
					<div className='logo'>
						<Image fluid
							src='/images/chat-icon.svg' 
							style={{width:'30px', height:'30px', marginRight:'4px'}}/>
            				<span className='fw-bold' style={{fontSize:'1.2em'}}>QuickyChat</span>
					</div>
					<p className='py-2'>&copy; {new Date().getFullYear()} QuickyChat. All rights reserved.</p>
				</Col>
				<Col className='text-center'>
					<h5>Product</h5>
					<ul>
						{/* <li>
							<Link to={'/overview'}>Overview</Link>
						</li> */}
						<li>
							<Link to={'/quickstart'}>quickstart</Link>
						</li>
						<li>
							<Link to={'/solutions'}>Solutions</Link>
						</li>
						<li>
							<Link to={'/pricing'}>Pricing</Link>
						</li>
					</ul>
				</Col>
				<Col className='text-center'>
					<h5>Company</h5>
					<ul>
						<li>
							<Link to={'/privacy-policy'}>Privacy Policy</Link>
						</li>
					</ul>
				</Col>
			</Row>
		</Container>
	)
}

export default Footer